import { render, staticRenderFns } from "./LevelManagement.vue?vue&type=template&id=0ab9c4b0"
import script from "./LevelManagement.vue?vue&type=script&lang=js"
export * from "./LevelManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports